import { useLayoutEffect, useState } from "react";

/**
 * To identify window size changes.
 * @returns {Object} - Updated width and height of the screen as a state variable
 */
export default function useWindowSize() {
  const [size, setSize] = useState([0, 0]);

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    window.addEventListener("resize", updateSize);
    updateSize();

    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return size;
}
